import i18n from 'i18next';

/**
 * Reads from the `i18next` singleton, so it works outside React (e.g., from
 * the axios interceptor in `middleware.utils.ts`). The `defaultValue` is the
 * source English string — used only as a defensive fallback if i18n hasn't
 * initialized yet (shouldn't happen in app shell).
 */
export const getUpgradeCancelledMessage = (): string =>
  i18n.t('billing.errors.upgradeRequiredToContinue', {
    defaultValue:
      'A payment method upgrade is required to continue. Please add a Stripe-supported card to proceed.',
  });

/**
 * User-facing copy for 409 `idempotency_key_conflict` — instructs the user
 * to refresh, since reusing the same client-side intent would collide again.
 */
export const getRequestStaleMessage = (): string =>
  i18n.t('billing.errors.requestStaleRefreshAndRetry', {
    defaultValue:
      "Your request couldn't be processed. Please refresh the page and try again.",
  });

/**
 * App-wide fallback message — used by the 428 `idempotency_key_required`
 * branch in the axios interceptor. The 428 case is an FE bug, so the user
 * sees a generic message while devs see `Logger.error` in observability.
 */
export const getSomethingWentWrongMessage = (): string =>
  i18n.t('somethingWentWrong', {
    defaultValue: 'Something went wrong. Please try again.',
  });
